/* eslint import/prefer-default-export: "off" */

export const defaultPageSize = 100
